import React, { useEffect, useState } from "react";
import Datatable from "../../../../core/common/dataTable";

const QuickInfoModal = ({ title, dataSource, columns }: any) => {
  useEffect(() => {
    const modalElement = document.getElementById("reports-stats-info-modal");

    if (modalElement) {
      const handleModalShow = () => {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = "0px";
        document.documentElement.style.overflow = "hidden";
      };

      const handleModalHide = () => {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
        document.documentElement.style.overflow = "";
      };

      modalElement.addEventListener("show.bs.modal", handleModalShow);
      modalElement.addEventListener("hide.bs.modal", handleModalHide);
      modalElement.addEventListener("hidden.bs.modal", handleModalHide);

      return () => {
        modalElement.removeEventListener("show.bs.modal", handleModalShow);
        modalElement.removeEventListener("hide.bs.modal", handleModalHide);
        modalElement.removeEventListener("hidden.bs.modal", handleModalHide);
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
        document.documentElement.style.overflow = "";
      };
    }
  }, []);

  return (
    <>
      <div
        className="modal fade"
        id="reports-stats-info-modal"
        tabIndex={-1}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        style={{ overflow: "hidden" }}>
        <div className="modal-dialog modal-fullscreen">
          <div
            className="modal-content"
            style={{ maxHeight: "100vh", overflow: "hidden" }}>
            <div className="modal-header">
              <h4 className="modal-title">{title || "List"}</h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                data-bs-dismiss="modal"></button>
            </div>
            <div
              className="modal-body p-0"
              style={{ overflowY: "auto", maxHeight: "calc(100vh - 140px)" }}>
              <Datatable
                key={JSON.stringify(dataSource)}
                dataSource={dataSource}
                columns={columns}
              />
            </div>
            <div className="modal-footer border-top">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuickInfoModal;
